import { create } from 'zustand'
import { DEFAULT_INTERVAL_REPORT_SETTINGS } from '../../../../utils/constants'
import { IntervalReportSettings, IntervalDisplayParam } from '@/hooks'
import { ViewType } from '@/stores/useViewAsToggle/useViewAsToggle'

export type ActiveManagementStoreState = {
    intervalData: {
        reportSettings: IntervalReportSettings
        setReportSettings: (settings: Partial<IntervalReportSettings>) => void
        hasDefaultSettings: boolean
        resetReportSettings: () => void
        hoveredDisplaySetting: IntervalDisplayParam | null
        setHoveredDisplaySetting: (display: IntervalDisplayParam | null) => void
        selectedView: ViewType
        setSelectedView: (view: ViewType) => void
    }
}

const checkDefaultSettings = (settings: IntervalReportSettings) =>
    JSON.stringify(settings) ===
    JSON.stringify(DEFAULT_INTERVAL_REPORT_SETTINGS)

const useActiveManagementStore = create<ActiveManagementStoreState>((set) => ({
    intervalData: {
        reportSettings: DEFAULT_INTERVAL_REPORT_SETTINGS,
        hasDefaultSettings: true,
        hoveredDisplaySetting: null,
        selectedView: 'chart',
        setReportSettings: (
            partialSettings: Partial<IntervalReportSettings>
        ) => {
            set((state) => {
                const updatedSettings: IntervalReportSettings = {
                    ...state.intervalData.reportSettings,
                    ...partialSettings,
                }

                return {
                    intervalData: {
                        ...state.intervalData,
                        reportSettings: updatedSettings,
                        hasDefaultSettings:
                            checkDefaultSettings(updatedSettings),
                    },
                }
            })
        },
        resetReportSettings: () => {
            set((state) => ({
                intervalData: {
                    ...state.intervalData,
                    reportSettings: DEFAULT_INTERVAL_REPORT_SETTINGS,
                    hasDefaultSettings: true,
                },
            }))
        },
        setHoveredDisplaySetting: (display) => {
            set((state) => ({
                intervalData: {
                    ...state.intervalData,
                    hoveredDisplaySetting: display,
                },
            }))
        },
        setSelectedView: (view) => {
            set((state) => ({
                intervalData: {
                    ...state.intervalData,
                    selectedView: view,
                },
            }))
        },
    },
}))

export default useActiveManagementStore
